import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export function NotFoundBlock({ title = "Not Found", message, backTo = "/", backLabel = "Back to Home" }) {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-cream px-4 pt-24">
      <div className="max-w-md rounded-3xl border border-gold/25 bg-white p-10 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-saffron/10"><Compass className="h-7 w-7 text-saffron" /></div>
        <h1 className="mt-5 font-display text-3xl font-bold text-charcoal">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{message || "The page you're looking for isn't available. It may have been moved or customized."}</p>
        <Link to={backTo} className="mt-6 inline-block"><Button className="rounded-full bg-saffron font-accent font-semibold text-white hover:bg-saffron-dark">{backLabel}</Button></Link>
      </div>
    </div>
  );
}
